var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H1a1 1 0 1 0 0 2h14a1 1 0 0 0 0-2ZM1 16h.09l4.17-.38a2 2 0 0 0 1.21-.57l9-9a1.92 1.92 0 0 0-.07-2.71L12.66.6A2 2 0 0 0 10 .53l-9 9a2 2 0 0 0-.57 1.21L0 14.91A1 1 0 0 0 1 16ZM11.27 2 14 4.73l-2 1.95L9.32 4l1.95-2Zm-8.9 8.91L8 5.32l2.7 2.7-5.6 5.6-3 .28.27-2.99Z",
    fill: "#73777A"
  })));
};
export default SvgEditIcon;